import { Component } from '@angular/core';

@Component({
  selector: 'app-about-redesign',
  templateUrl: './about-redesign.component.html',
  styleUrls: ['./about-redesign.component.scss']
})
export class AboutRedesignComponent {

}
